// extracted by mini-css-extract-plugin
export default {"homeworkCheck":"HomeworkCheck_homeworkCheck__aaeX9","button":"HomeworkCheck_button__YZeba","container":"HomeworkCheck_container__rW9zc"};